import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import giftbox from "../assets/present.svg";
import phone from "../assets/smartphone.svg";
import trophy from "../assets/trophy.svg";
import category from "../assets/category.svg";
import { Link, useNavigate } from "react-router-dom";
import quizData from "../data/quizdata";
import Adsense from "./Adsense";
import { addCoins, CORRECT_REWARD, WRONG_PENALTY } from "../utils/coins";

function Homepage() {
 

  const navigate = useNavigate();

  const questions = quizData.homequiz || [];

  const [currentQ, setCurrentQ] = useState(0);
  const [selected, setSelected] = useState("");
  const [score, setScore] = useState(0);

  const handleAnswer = (option) => {
    if (selected) return;

    setSelected(option);

      let updatedScore = score;

  if (option === questions[currentQ]?.correctAnswer) {
    // correct answer → add coins
    updatedScore += CORRECT_REWARD;
    addCoins(CORRECT_REWARD);
  } else {
    // wrong answer → subtract coins
    updatedScore -= WRONG_PENALTY;
    addCoins(-WRONG_PENALTY);
  }
  setScore(updatedScore);

    setTimeout(() => {
      // last question
      if (currentQ >= questions.length - 1) {
        navigate("/start", {
        state: {
          score: updatedScore,
        },
      });
        return;
      }

      // next question
      setCurrentQ((prev) => prev + 1);
      setSelected("");
    }, 1000);
  };

  const getClass = (option) => {
    if (!selected) return "option-btn";

    if (option === questions[currentQ]?.correctAnswer) {
      return "option-btn correct";
    }

    if (option === selected) {
      return "option-btn wrong";
    }

    return "option-btn";
  };
  return (
    <>
      <div className="main">
        <div className="main-div">
          <div className="container mt-2">
            {/* <div>
            <Adsense slot="6300978111"/>
            </div> */}
            <div className="mt-2 content-div">
              <div>
                {/* <Link to="/category" className="nav-link">
                  category
                </Link> */}
                <h3>Quick Start !</h3>
                <h6>Answer 2 questions and win upto 200 coins.</h6>
                {/* <div className="card mt-3">
        <div>
         Who directed the movie 'Parasite'?
         <Row className="mt-3">
          <Col xs={12} md={6} className="mb-3">
          <div className="option">Guillermo del Toro</div>
          </Col>
          <Col xs={12} md={6} className="mb-3">
          <div className="option">Alejandro Gonzålez</div>
          </Col>
          <Col xs={12} md={6} className="mb-3">
          <div className="option">Alfonso Cuarön</div>
          </Col>
          <Col xs={12} md={6} className="mb-3">
          <div className="option">Pedro Almodövar</div>
          </Col>
         </Row>
         </div>
        </div> */}
                <div className="quiz-wrapper">
                  <div className="quiz-card mt-5">
                    {/* QUESTION NUMBER */}
                    <div className="question-count">
                      {currentQ + 1}/{questions.length} Question
                    </div>

                    {/* QUESTION */}
                    <h5 className="question-title">
                      {questions[currentQ]?.question}
                    </h5>

                    {/* OPTIONS */}
                     <Row className="mt-4 mb-4" style={{
                       rowGap: "15px",
                      "--bs-gutter-x": "1.5rem",
                      paddingRight: "calc(var(--bs-gutter-x) * .3)",
                      paddingLeft: "calc(var(--bs-gutter-x) * .3)",
                      }}>
                      {questions[currentQ]?.options?.map((opt, i) => (
                        <Col xs={6} className="" key={i}>
                          <button
                            className={getClass(opt)}
                            onClick={() => handleAnswer(opt)}
                          >
                            {opt}
                          </button>
                        </Col>
                      ))}
                    </Row>
                  </div>
                </div>
              </div>
              <div className="mt-4">
                <h3>Why Choose Our Platform?</h3>
                <Row className="d-flex mt-4 ">
                  <Col xs={12} md={6} className="mb-3">
                    <div className="card-option">
                      <img
                        src={giftbox}
                        alt="Gift Box"
                        style={{ height: "35px" }}
                      />
                      <h6 className="mt-3">Daily Rewards</h6>
                      <p>Login daily to get bonus coins and special rewards</p>
                    </div>
                  </Col>
                  <Col xs={12} md={6} className="mb-3">
                    <div className="card-option">
                      <img src={phone} alt="Phone" style={{ height: "35px" }} />
                      <h6 className="mt-3">Mobile Friendly</h6>
                      <p>
                        Play seamlessly on any device mobile, tablet, or desktop
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} md={6} className="mb-3">
                    <div className="card-option">
                      <img
                        src={trophy}
                        alt="Trophy"
                        style={{ height: "35px" }}
                      />
                      <h6 className="mt-3">Live Contests</h6>
                      <p>
                        Join real time quiz competitions with players worldwide
                      </p>
                    </div>
                  </Col>
                  <Col xs={12} md={6} className="mb-3">
                    <div className="card-option">
                      <img
                        src={category}
                        alt="Category"
                        style={{ height: "35px" }}
                      />
                      <h6 className="mt-3">10+ Categories</h6>
                      <p>GK , Cricket , Bollywood , Business and more</p>
                    </div>
                  </Col>
                </Row>
              </div>
              {/* <div >
              <Adsense slot="6300978111"/>
              </div> */}

              <div className="card play-div mb-5 mt-3">
                <h3>How To Play?</h3>
                <div className="mt-2">
                  <ol type="1" className="d-flex flex-column gap-2 mb-0">
                    <li>Select your favorite quiz category</li>
                    <li>Answer questions correctly to earn coins</li>
                    <li>Compete on leaderboards</li>
                    <li>Redeem coins for exciting rewards</li>
                  </ol>
                </div>
              </div>
              <div>
                <h3>Play Quiz and Win Coins!</h3>
                <ul className="play-div container d-flex flex-column gap-2">
                  <li>
                    Play Quizzes in 25+ categories like GK, Sports, Bollywood,
                    Business, Cricket & more!
                  </li>
                  <li>Compete with lakhs of other players!</li>
                  <li>Win coins for every game</li>
                  <li>
                    Trusted by millions of other quiz enthusiasts like YOU!
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Homepage;
